export default __webpack_public_path__ + "static/main-cup-light-green-273e44606a22aed46c9228e89e90033e.png";